/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Carrier_Inspection_With_FeeInputs */

const vi_carrier_inspection_with_fee = /** @type {(inputs: Carrier_Inspection_With_FeeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Có (khách xem rồi không nhận thì Viettel Post thu ${i?.fee})`)
};

/**

* @param {Carrier_Inspection_With_FeeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_inspection_with_fee = /** @type {((inputs: Carrier_Inspection_With_FeeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Inspection_With_FeeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_inspection_with_fee(inputs)
});